import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Merge, X, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

// După import Saga: furnizori manuali care seamănă la nume cu unul Saga, dar nu s-au unit automat — unire cu un click
export default function SimilarSuppliersPanel({ items, onChanged, onClose }) {
  const [busy, setBusy] = useState(null);
  if (!items?.length) return null;
  const merge = async (it) => {
    if (!window.confirm(`Unești „${it.manual_name}” (${it.manual_cod}) cu „${it.saga_name}” (${it.saga_cod})? Documentele și plățile trec pe furnizorul Saga.`)) return;
    setBusy(it.manual_cod + it.saga_cod);
    try { await axios.post(`${API_URL}/furnizori/${it.manual_id}/uneste`, { target_cod: it.saga_cod }, auth()); toast.success('Furnizori uniți'); onChanged?.(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Eroare'); }
    finally { setBusy(null); }
  };
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 space-y-2" data-testid="similar-suppliers-panel">
      <div className="flex items-start justify-between gap-2">
        <div className="text-xs text-amber-900"><b>Furnizori manuali care seamănă cu unii din Saga</b> — nu s-au unit automat pentru că numele nu e identic. Verifică și unește dacă e același furnizor.</div>
        <button type="button" onClick={onClose} className="text-amber-700 hover:text-amber-900" data-testid="similar-suppliers-close"><X className="w-4 h-4" /></button>
      </div>
      <div className="space-y-1">
        {items.map((it) => (
          <div key={it.manual_cod + it.saga_cod} className="flex flex-wrap items-center gap-2 text-xs bg-white rounded border px-2 py-1.5" data-testid={`similar-${it.manual_cod}-${it.saga_cod}`}>
            <span className="font-medium">{it.manual_name}</span><span className="text-slate-400">({it.manual_cod}, manual)</span>
            <span className="text-slate-400">≈</span>
            <span className="font-medium">{it.saga_name}</span><span className="text-slate-400">({it.saga_cod}, Saga)</span>
            <Button size="sm" variant="outline" className="h-6 px-2 ml-auto" disabled={!!busy} onClick={() => merge(it)} data-testid={`similar-merge-${it.manual_cod}-${it.saga_cod}`}>
              {busy === it.manual_cod + it.saga_cod ? <Loader2 className="w-3 h-3 animate-spin" /> : <Merge className="w-3 h-3 mr-1" />} Unește
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
